import React from 'react';

import { PlusIcon } from '@vlabs/icons';
import { ZoneItem } from '@vlabs/shared/components/zone-item/ZoneItem';
import { Control } from '@vlabs/uikit';
import { useTranslation } from 'react-i18next';

import st from './RegionsEditSideMenu.module.sass';

export function RegionsEditSideMenu({
  activeRegion = undefined,
  onAddDroiRegion = undefined,
  onChangeActiveRegion = undefined,
  onRemoveDroiRegion = undefined,
  roiRegion = undefined,
  droiList = undefined,
  isDrawing = false,
  onChangeRegion = undefined,
  droiAddDisabled = false,
}) {
  const { t } = useTranslation();

  const onZoneItemClick = (layer) => {
    onChangeActiveRegion?.(layer.id === activeRegion?.id ? null : layer);
  };

  return (
    <div className={st.Root}>
      <ZoneItem
        color={roiRegion?.color}
        isSelected={activeRegion?.id === roiRegion?.id}
        isVisible={roiRegion?.isVisible}
        onChangeVisibility={() => onChangeRegion?.({ ...roiRegion, isVisible: !roiRegion.isVisible })}
        onZoneClick={() => onZoneItemClick(roiRegion)}
      />

      <div className={st.DroiMenu}>
        <p className={st.DroiMenu__Title}>
          {t('roi.modal.droi_zones')}
        </p>

        <div className={st.DroiMenu__List}>
          {droiList.map(((droiRegion, index) => (
            <ZoneItem
              canHide={!isDrawing || droiRegion.id !== activeRegion.id}
              color={droiRegion.color}
              isSelected={activeRegion?.id === droiRegion.id}
              isVisible={droiRegion?.isVisible}
              key={droiRegion.id}
              layerNumber={index + 1}
              onChangeVisibility={() => onChangeRegion?.({ ...droiRegion, isVisible: !droiRegion.isVisible })}
              onRemove={() => onRemoveDroiRegion?.(droiRegion.id)}
              onZoneClick={() => onZoneItemClick(droiRegion)}
              regionType={droiRegion.type}
            />
          )))}

          <Control.Button
            data-testid="roiModal.addDroiLayerButton"
            disabled={isDrawing || droiAddDisabled || !onAddDroiRegion}
            icon={<PlusIcon />}
            onClick={onAddDroiRegion}
            size="small"
            variant="flat"
          >
            {t('btn.add')}
          </Control.Button>
        </div>
      </div>
    </div>
  );
}
